export const SIRIES_SELECTED = {
  header: 'Series Selected',
};

export default SIRIES_SELECTED;
